<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13Ip7pL/tc-custom/9781504058599.jpg?1734296372573" alt="This image is the cover for the book Company of Cats"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Company of Cats
      </h1>
      <p class="bookDescription body article font2">
        <b>A millionaire’s cat may be the key to a murder mystery in this delightful novel from an Agatha Award–winning author.</b><br/>  <br/> When Annabel Hinchby-Smythe accepts an offer to serve as interior decorator to computer mogul Arthur Arbuthnot, she can’t help noticing that no one in the house seems to genuinely like the tycoon—aside from his cat, Sally.<br/>  <br/> After Arthur’s sudden death—and the revelation that Sally is named sole inheritor in his will—Annabel’s new task will be finding out the truth about her client’s demise, and keeping the furry heiress safe from harm.<br/>  <br/> “Her portrayal of the kindhearted, martini-swigging Annabel is a winner.” —<i>Booklist </i><br/>  <br/><b>Praise for Marian Babson</b><br/> “Marian Babson’s name on a mystery is a guarantee of quality writing wrapped around an unusual crime.” —<i>Houston Chronicle</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marian Babson
      </h2>
      
      <p class="authorDescription body article">Marian Babson, born Ruth Stenstreem, is an American mystery writer. Her first published work was <I>Cover-Up Story</I> (1971), and she has written over forty-five mysteries. Babson served as secretary of the Crime Writers&rsquo; Association and was awarded the CWA Dagger in the Library in 1996.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77011000